import React from 'react';
import { Link } from "react-router-dom";
import { FlatRateAgreement } from '../../flatRates/types';

type MainProps = {
  flatRateAgreement?: FlatRateAgreement;
  requestType?: string;
  creditUrl?: string;
}

const Main: React.FC<MainProps> = ({
  flatRateAgreement,
  requestType,
  creditUrl
}) => {
  return (
		<main id="page-user_index" className="wrapper">
      <div className="sec-link mtpc-20 mtsp-20">
        <div className="inner">
          <ul className="link-list">
            {flatRateAgreement?.status === "before_confirmation" && 
              <li className="link-list__item link-list__item--full">
                <Link to="/customer/flat_rates/registration">
                  <span>まずはこちらをご確認ください</span> 新規契約の確認・確定 
                </Link>
              </li>
            }
            {(requestType && requestType === 'change_plan_request') && 
              <li className="link-list__item link-list__item--full">
                <Link to="/customer/flat_rates/change_plan_request/confirm">
                  契約内容変更の確認・確定
                </Link>
              </li>
            }
            {(requestType && requestType === 'cancel_request') && 
              <li className="link-list__item link-list__item--full">
                <Link to="/customer/flat_rates/cancel_request/confirm">
                  キャンセル内容の確認・確定
                </Link>
              </li>
            }
            {(requestType && requestType === 'terminate_request') && 
              <li className="link-list__item link-list__item--full">
                <Link to="/customer/flat_rates/terminate_request/confirm">
                  解約内容の確認・確定
                </Link>
              </li>
            }
            {(requestType && requestType === 'lost_non_warranty_request') && 
              <li className="link-list__item link-list__item--full">
                <Link to="/customer/flat_rates/lost_non_warranty_request/confirm">
                  保証外紛失レンズ内容の確認・確定
                </Link>
              </li>
            }
            {flatRateAgreement?.status !== "before_confirmation" &&
              <>
                <li className="link-list__item">
                  <Link to="/customer/edit_info"> お客様ご登録基本情報の変更</Link>
                </li>
                <li className="link-list__item">
                  <Link to={creditUrl || ""}> ご登録クレジットカード<br className="pc"/>情報の変更 </Link>
                </li>
              </>
            }
          </ul>
        </div>
      </div>
    </main>
  )
}

export default Main;